import type { DeviceLinkConflictRequestSummary } from '../types';

/**
 * Extract client IP from sync event request headers (Studio link attempts).
 */
export function getClientIpFromHeaders(
  headers: Record<string, string> | null | undefined
): string | null {
  if (!headers) return null;
  const normalized = Object.fromEntries(
    Object.entries(headers).map(([k, v]) => [k.toLowerCase(), v])
  );
  const forwarded = normalized['x-forwarded-for'];
  if (forwarded) {
    return forwarded.split(',')[0]?.trim() || null;
  }
  return normalized['x-real-ip'] || null;
}

export function isDeviceLinkConflictRequestSummary(
  summary: unknown
): summary is DeviceLinkConflictRequestSummary {
  if (!summary || typeof summary !== 'object') return false;
  const s = summary as Record<string, unknown>;
  return (
    typeof s.device_id === 'string' &&
    typeof s.attempted_by_email === 'string' &&
    typeof s.existing_owner_email === 'string'
  );
}
